module.exports = __webpack_public_path__ + "static/img/sequence-1.b5ff959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/sequence-1.jpg
// module id = XB0C
// module chunks = 0